<template>
  <li class="relative">
    <div v-if="!draft.noteSubmitted">
      <div class="px2 mb1 h6 flex justify-between items-end">
        <span>
          <strong>{{ userName }}</strong><br/>
          <span v-if="locationText">{{ locationText }}</span>
        </span>
        <div class="relative">
          <a @focus="showMenu = true" @blur="showMenu = false" class="pointer outline-none" tabindex="0"><dot-icon/></a>
          <transition name="fade">
            <div v-if="showMenu" :key="draft.draftKey" class="absolute bg-white py2 pl2 pr1 right-0 top-100 nowrap z1 mxn2">
              <ul class="list-reset right-align">
                <li class="p1 mb0">
                  <a @click="editDraft" class="pointer">Edit / Upload</a>
                </li>
                <li class="p1 mb0">
                  <a @click="deleteDraft(draft.draftKey)" class="pointer">Delete</a>
                </li>
              </ul>
            </div>
          </transition>
        </div>
        <!-- <div @click="deleteDraft(draft.draftKey)">Delete</div> -->
      </div>
      <div class="note-format mb2">
        <!-- image -->
        <figure v-if="draft.isImage" class="wp-block-image">
          <img class="wp-image-140" :src="draft.previewUrl" alt="" loading="lazy"/>
          <figcaption class="h5"><span class="sans gray h6">{{ dateModified }}</span> {{ draft.text }}</figcaption>
        </figure>
        <!-- video -->
        <figure v-else-if="draft.isVideo" class="wp-block-video">
          <video :src="draft.previewUrl" :type="draft.fileType" controls loading="lazy" playsinline></video>
          <figcaption class="h5"><span class="sans gray h6">{{ dateModified }}</span> {{ draft.text }}</figcaption>
        </figure>
        <!-- audio -->
        <figure v-else-if="draft.isAudio" class="wp-block-audio">
          <audio :src="draft.previewUrl" controls loading="lazy"></audio>
          <figcaption class="h5"><span class="sans gray h6">{{ dateModified }}</span> {{ draft.text }}</figcaption>
        </figure>

        <!-- text -->
        <div v-else :class="blockClass" class="wp-block-text">
          <div @click="expanded = !expanded" :class="{ expanded }" class="note-content">
            <div v-html="draft.text"></div>
          </div>
          <div class="h6 pt2 mt1">{{ dateModified }}</div>

          <!-- taxonomies -->
          <div v-if="shownTags.length" class="tags px2">
            <template v-for="tag in shownTags">
              <tag-item :tag="tag" :key="tag.ID || tag.id"/>
              <span :key="(tag.ID || tag.id) + 'sp'">&ensp;</span>
            </template>
            <span v-if="expandableTags" @click="expandedTags = true" class="gray pointer">more...</span>
          </div>
        </div>
        <div v-if="draft.hasErrors" class="red h6 px2 strong">
          <p>{{ (draft.fileErrors[0] || draft.uploadErrors[0]).message }}.</p>
          <span> Please try again later</span>
        </div>

        <!-- taxonomies -->
        <div v-if="shownTags.length && draft.hasFile" class="tags px2">
          <template v-for="tag in shownTags">
            <tag-item :tag="tag" :key="tag.ID || tag.id"/>
            <span :key="(tag.ID || tag.id) + 'sp'">&ensp;</span>
          </template>
          <span v-if="expandableTags" @click="expandedTags = true" class="gray pointer">more...</span>
        </div>
      </div>
    </div>

    <div v-else class="bg-silver p3 center">
      <span class="h5">Field note uploaded!</span>
    </div>

    <div v-if="draft.processing" class="absolute top-0 right-0 left-0 bottom-0 bg-lighten-4 flex flex-column items-center justify-center">
      <span class="h5">Processing</span>
      <div class="px2 col-12 border-box">
        <div :style="{ width: `${draft.progress}%` }" class="progress-bar bg-green rounded my1"></div>
      </div>
    </div>
  </li>
</template>

<script>
  import { mapActions } from 'vuex'
  import { distanceInWordsToNow } from 'date-fns'
  import TagItem from '@/components/TagItem'

  export default {
    name: 'DraftPreview',
    props: {
      draft: Object
    },
    data () {
      return {
        showMenu: false,
        expanded: false,
        expandedTags: false
      }
    },
    computed: {
      dateModified () {
        return `${distanceInWordsToNow(
          new Date(this.draft.draftKey)
        )} ago`
      },
      locationText () {
        if (this.draft && this.draft.location && this.draft.location !== 'undefined') {
          return this.draft.location
        } else {
          return null
        }
      },
      userName () {
        const userInfo = this.$store.state.userInfo
        return userInfo ? userInfo.name : ''
      },
      blockClass () {
        return this.expanded && 'expanded'
      },
      terms () {
        let terms = []
        terms.push(...this.draft.taxonomies.method)
        terms.push(...this.draft.taxonomies.keyword)
        terms.push(...this.draft.taxonomies.folksonomy)
        return terms
      },
      allTags () {
        return [
          ...this.draft.linkedProjects,
          ...this.terms
        ]
      },
      shownTags () {
        return this.expandedTags ? this.allTags : this.allTags.slice(0, 3)
      },
      expandableTags () {
        return this.shownTags.length < this.allTags.length
      },
      hasMedia () {
        return !!this.draft.mediaInfo
      }
    },
    methods: {
      editDraft () {
        this.$router.push(`?edit=${this.draft.draftKey}`)
      },

      ...mapActions(['deleteDraft'])
    },
    watch: {
      'draft.noteSubmitted' (newVal) {
        if (newVal) {
          this.$store.commit('ADD_MY_NOTE', newVal)
          this.deleteDraft(this.draft.draftKey)
        }
      },
      'draft.mediaInfo' (newVal) {
        if (newVal) {
          this.$store.dispatch('storeDraft', {
            key: this.draft.draftKey,
            data: this.draft
          })
        }
      }
    },
    components: { TagItem }
  }
</script>
